// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"7080278d","1973":"6cef3bd1","4566":"7080278d","9696":"6cef3bd1"}[chunkId] + ".chunk.css";
};